// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ninput[data-v-27f17025]:-moz-placeholder,\r\ntextarea[data-v-27f17025]:-moz-placeholder {\r\n  color: #495057 !important;\n}\ninput[data-v-27f17025]:-ms-input-placeholder,\r\ntextarea[data-v-27f17025]:-ms-input-placeholder {\r\n  color: #495057 !important;\n}\ninput[data-v-27f17025]::-webkit-input-placeholder,\r\ntextarea[data-v-27f17025]::-webkit-input-placeholder {\r\n  color: #495057 !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
